import { createAction } from 'redux-actions';
import initialState from './initialState';
import formatActionTypeNames from '../helpers/formatActionTypeNames';

import { actions as appActions } from './app.reducer';

export const actions = formatActionTypeNames(
	{
		getUser: 'GET_USER',
		getUserComplete: 'GET_USER_COMPLETE',
		signup: 'SIGNUP',
		signupComplete: 'SIGNUP_COMPLETE',
		login: 'LOGIN',
		loginComplete: 'LOGIN_COMPLETE',
		logout: 'LOGOUT',
		logoutComplete: 'LOGOUT_COMPLETE',
		resetPassword: 'RESET_PASSWORD',
		forgotPassword: 'FORGOT_PASSWORD',
	},
	'AUTH'
);

export const authActions = {
	getUser: createAction(actions.getUser),
	getUserComplete: createAction(actions.getUserComplete),
	signup: createAction(actions.signup),
	signupComplete: createAction(actions.signupComplete),
	login: createAction(actions.login),
	loginComplete: createAction(actions.loginComplete),
	logout: createAction(actions.logout),
	logoutComplete: createAction(actions.logoutComplete),
	resetPassword: createAction(actions.resetPassword),
	forgotPassword: createAction(actions.forgotPassword),
};

export default (state = initialState.auth, action) => {
	const { payload } = action;

	switch (action.type) {
		case appActions.booted:
			return {
				...state,
				user: payload.user,
			};

		case actions.getUserComplete:
			return {
				...state,
				user: payload.user,
			};

		case actions.signupComplete:
		case actions.loginComplete:
			return {
				...state,
				user: payload.user,
			};

		case actions.logoutComplete:
			return initialState.auth;

		default:
			return state;
	}
};
